module.exports = __webpack_public_path__ + "static/media/richmondLunch.5c7567c0.pdf";